<div
  id="client"
  *ngIf="
    (this.userId == 0 || this.userId == Number(this.authService.currentUserIds) || this.userId == null) &&
    !isModeEdition
  "
>
  <div class="title">
    <h3>Cliente</h3>

    <div class="rfcWrapper">
      <label class="checkboxWrapper" for="conRFC">
        <input
          type="checkbox"
          id="conRFC"
          [checked]="isClientWithRFC()"
          [disabled]="forceReadOnly"
          (change)="onCheckboxChange($event)"
        />
        <span class="checkmark"></span>
        <span class="description">Con RFC</span>
      </label>
      <div class="acciones">
        @if (!forceReadOnly && isClientWithRFC() && formHasRFC) {
          <a tp="Seleccionar otro cliente" class="refresh" (click)="openModalSelectClient()"
            >Seleccionar otro cliente</a
          >
        }
        @if (isEditable) {
          <a class="edit" tp="Editar cliente" (click)="openEditClient()">Editar</a>
        }
      </div>
    </div>
    @if (featureLoyaltyFeriaQuotation) {
      <div class="loyaltyFeriaFlags" aria-label="Cliente Feria">
        <label class="checkboxWrapper" for="stdFeria">
          <input
            type="checkbox"
            id="stdFeria"
            [ngModel]="formCustomer.get('feriaCustomer')?.value"
            (ngModelChange)="onFeriaCustomerToggle($event)"
          />
          <span class="checkmark"></span>
          <span class="description">Cliente de feria</span>
          <span class="fairBadge"><img src="./assets/images/icons/fair_event.svg" alt="Ícono feria" /></span>
        </label>
      </div>
    }
  </div>
  <form [formGroup]="formCustomer">
    @if (!isClientWithRFC()) {
      <!-- Form para clientes sin RFC - Información básica para cotización ágil -->
      <div>
        <div class="wrapperG5">
          <div class="controlWrapper">
            <label for="">Tipo de persona <span class="required">*</span></label>
            <div class="customSelect">
              <select
                type="text"
                formControlName="personType"
                (ngModelChange)="validatorChange()"
                (keypress)="allowAlphabeticCharacter($event)"
              >
                <option [value]="'NATURAL_PERSON'" selected>Persona física</option>
                <option [value]="'LEGAL_PERSON'" selected>Persona moral</option>
              </select>
            </div>
            <div
              class="error"
              *ngIf="formCustomer.get('personType')?.hasError('required') && formCustomer.get('personType')?.touched"
            >
              El campo es requerido.
            </div>
          </div>
          <div class="controlWrapper" *ngIf="this.formCustomer.controls['personType'].value == 'NATURAL_PERSON'">
            <label for="paternalSurname">Apellido paterno <span class="required">*</span></label>
            <input
              name=""
              type="text"
              id="paternalSurname"
              formControlName="lastName"
              (keydown)="allowOnlyLettersAndNumbers($event)"
              (input)="cleanNaturalPersonInput($event)"
              (paste)="onPasteNaturalPerson($event)"
            />
          </div>
          <div class="controlWrapper" *ngIf="this.formCustomer.controls['personType'].value == 'NATURAL_PERSON'">
            <label for="maternalSurname">Apellido materno</label>
            <input
              name=""
              type="text"
              id="maternalSurname"
              formControlName="mothersLastName"
              (keydown)="allowOnlyLettersAndNumbers($event)"
              (input)="cleanNaturalPersonInput($event)"
              (paste)="onPasteNaturalPerson($event)"
            />
          </div>
          <div
            class="controlWrapper"
            [ngClass]="{
              x4: formCustomer.controls['personType'].value !== 'NATURAL_PERSON',
            }"
          >
            <label for="customerName">Nombre <span class="required">*</span></label>
            <input
              name="customerName"
              type="text"
              id="customerName"
              formControlName="firstName"
              (keydown)="
                this.formCustomer.controls['personType'].value == 'NATURAL_PERSON'
                  ? allowOnlyLettersAndNumbers($event)
                  : allowAlphabeticCharacter($event)
              "
              (input)="
                this.formCustomer.controls['personType'].value == 'NATURAL_PERSON'
                  ? cleanNaturalPersonInput($event)
                  : null
              "
              (paste)="
                this.formCustomer.controls['personType'].value == 'NATURAL_PERSON' ? onPasteNaturalPerson($event) : null
              "
            />
          </div>
          <div class="controlWrapper" *ngIf="this.formCustomer.controls['personType'].value == 'NATURAL_PERSON'">
            <label for="secondName">Segundo nombre</label>
            <input
              name=""
              type="text"
              id="secondName"
              formControlName="secondName"
              (keydown)="allowOnlyLettersAndNumbers($event)"
              (input)="cleanNaturalPersonInput($event)"
              (paste)="onPasteNaturalPerson($event)"
            />
          </div>
        </div>
      </div>
    } @else {
      <!-- Form para clientes con RFC - Información completa del cliente para cotizar -->
      <div>
        <div class="wrapperG4 withRfc">
          <!-- Mostrar si el cliente está seleccionado -->
          @if (personType) {
            <div class="controlWrapper">
              <label>Tipo de persona</label>
              <span class="value">{{ clientsService.getPersonType(personType) }}</span>
            </div>
          }
          @if (rfc) {
            <div class="controlWrapper">
              <label>RFC</label>
              <span class="value">{{ rfc }}</span>
            </div>
          }
          @if (!isLegalPerson()) {
            @if (lastName) {
              <div class="controlWrapper">
                <label>Apellido paterno</label>
                <span class="value">{{ lastName }}</span>
              </div>
            }
            @if (mothersLastName) {
              <div class="controlWrapper">
                <label>Apellido materno</label>
                <span class="value">{{ mothersLastName }}</span>
              </div>
            }
          }
          @if (name) {
            <div class="controlWrapper x2" [ngClass]="{ moral: isLegalPerson() }">
              <label>Nombre</label>
              <span class="value">{{ name }}</span>
            </div>
          }
        </div>
        <!-- Mostrar sin no hay ningun cliente seleccionado -->
        @if (!forceReadOnly && !formHasRFC) {
          <div class="actions withRfc">
            <button class="tertiary" (click)="openModalSelectClient()" tabindex="9">Seleccionar cliente</button>
          </div>
        }
      </div>
    }

    <!-- @if (featureLoyaltyFeriaQuotation) {
      <div class="loyaltyFeriaFlags" aria-label="Cliente Feria">
        <label class="checkboxWrapper" for="stdFeria">
          <input type="checkbox" id="stdFeria" formControlName="feriaCustomer" />
          <span class="checkmark"></span>
          <span class="description">Cliente de feria</span>
          <span class="fairBadge"
            ><img src="./assets/images/icons/fair_event.svg" alt="Ícono feria"
          /></span>
        </label>
      </div>
    } -->
  </form>
</div>

<!-- Versión sólo lectura -->
<div id="client" *ngIf="(this.userId != Number(this.authService.currentUserIds) && this.userId > 0) || isModeEdition">
  <h3>Cliente</h3>
  <div>
    <div class="wrapperG4">
      <div class="controlWrapper">
        <label>Tipo de persona</label>
        <span class="value">{{ clientsService.getPersonType(formCustomer.controls['personType'].value) }}</span>
      </div>

      @if (rfc) {
        <div class="controlWrapper">
          <label>RFC</label>
          <span class="value">{{ rfc }}</span>
        </div>
      }

      @if (lastName) {
        <div class="controlWrapper" *ngIf="this.formCustomer.controls['personType'].value == 'NATURAL_PERSON'">
          <label>Apellido paterno</label>
          <span class="value">{{ lastName }}</span>
        </div>
      }

      <div class="controlWrapper" *ngIf="this.formCustomer.controls['personType'].value == 'NATURAL_PERSON'">
        <label>Apellido materno</label>
        <span class="value">{{ mothersLastName }}</span>
      </div>

      <!-- Si es persona moral agregar clase 'moral' a <div> -->
      @if (name) {
        <div class="controlWrapper" class="controlWrapper" [ngClass]="{ moral: isLegalPerson() }">
          <label>Nombre</label>
          <span class="value">{{ name }}</span>
        </div>
      }

      @if (secondName) {
        <div class="controlWrapper" *ngIf="this.formCustomer.controls['personType'].value == 'NATURAL_PERSON'">
          <label>Segundo nombre</label>
          <span class="value">{{ secondName }}</span>
        </div>
      }
    </div>
    @if (featureLoyaltyFeriaQuotation) {
      <div class="packageProgramsRow">
        <div class="controlWrapper">
          <label>Cliente de feria</label>
          <span class="value">{{ customerFeriaReadonlyYesNo() }}</span>
        </div>
      </div>
    }
  </div>
</div>

<ng-template #modalSelectClient>
  <app-client-form-modal (savedClient)="saveAndUpdateClientForm($event)" [client]="null"
    [disableRfcEdit]="true" (cancelModalE)="cancelModal($event)" />
</ng-template>
<ng-template #modalNewClient>
  <app-client-form-modal
    (savedClient)="saveAndUpdateClientForm($event)"
    [client]="selectedClient()"
    [disableRfcEdit]="true"
    (cancelModalE)="cancelModal($event)"
  />
</ng-template>
<ng-template #personTypeChangeConfirmation>
  <confirmation-dialog (closed)="handlePersonTypeChangeConfirmation($event)"></confirmation-dialog>
</ng-template>
